import { Box } from "@mui/material";
import React, { useEffect, useState } from "react";
import Searchbar from "../../../../Components/Searchbar/Searchbar";
import CustomButton from "../../../../Components/Button/CustomButton";
import { Link } from "react-router-dom";
import { GetRecipe } from "../../../../APIs/Function/Workout/Recipe/GetRecipe";
import RecipeTable from "../../../../Components/Table/RecipeTable";
import { SearchDebouncing } from "../../../../APIs/Search/SearchDebouncing";

const RecipePlans = () => {
  const [recipeData, setRecipeData] = useState([]);
  const [loading, setLoading] = useState(false);
  const [searched, setSearched] = useState(false);
  const [searchData, setSearchData] = useState([]);

  const handleRecipe = async () => {
    try {
      setLoading(true);
      let res = await GetRecipe();
      setRecipeData(res.r);
      setLoading(false);
    } catch (error) {
      console.log(error);
    }
  };
  const handleSearch = async (e) => {
    const searchValue = e.target.value.trim();
    if (searchValue.length === 0) {
      setSearchData([]);
      setSearched(false);
      return;
    }
    try {
      await SearchDebouncing(5, searchValue, setSearchData);
      setSearched(true);
    } catch (error) {
      console.log(error);
    }
  };

  useEffect(() => {
    handleRecipe();
  }, []);

  return (
    <Box sx={{ boxSizing: "border-box", p: 2 }}>
      {/* searchbar */}
      <Box>
        <Searchbar placeholder={"search"} onChange={handleSearch} />
      </Box>
      {searched && searchData.length > 0 ? (
        <RecipeTable
          RecipeData={searchData}
          setRecipeData={setRecipeData}
          loadinga={loading}
          Column1={"#"}
          Column2={"Photo"}
          column3={"Title"}
          Column4={"Action"}
        />
        ) : !searched ? (
        <RecipeTable
          RecipeData={recipeData}
          setRecipeData={setRecipeData}
          loadinga={loading}
          Column1={"#"}
          Column2={"Photo"}
          column3={"Title"}
          Column4={"Action"}
        />
      ):""}

      <Box
        sx={{
          display: "flex",
          mt: "25px",
          justifyContent: "end",
          width: "100%",
        }}
      >
        <Link to={"/addrecipeplans"}>
          <CustomButton
            sx={{
              width: "100%",
              bgcolor: "#31AEF4",
              "&:hover": {
                bgcolor: "#31AEF4",
              },
            }}
          >
            ADD +
          </CustomButton>
        </Link>
      </Box>
    </Box>
  );
};

export default RecipePlans;
